module.exports = __webpack_public_path__ + "static/img/ThinkPad_X1.258281cd.png";